import { DsIconButton } from '@frontends/ds';
import { useTheme } from '@frontends/util-theme-provider';
import { useTranslation } from 'react-i18next';

export function ThemeToggle() {
  const { setThemeMode, resolvedMode } = useTheme();
  const { t } = useTranslation();
  const isDark = resolvedMode === 'dark';
  const label = t(isDark ? 'switch_to_light_theme' : 'switch_to_dark_theme');

  return (
    <DsIconButton
      name={isDark ? 'sun' : 'moon'}
      aria-label={label}
      tooltip={label}
      onPress={() => setThemeMode(isDark ? 'light' : 'dark')}
    />
  );
}
